import {Injectable} from '@angular/core';
import {BackendService} from "./backend.service";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {ResponseDto} from "../dto/response.dto";

@Injectable({
  providedIn: 'root'
})
export class AdService {

  private urlPrefix = '/api/ad';

  constructor(private backend: BackendService) {}

  getOffersList(segmentId:any): Observable<any> {
    const url = `${this.urlPrefix}/list/segment/${segmentId}`;
    return this.backend.get(url).pipe(
        map((response: ResponseDto) => response.response)
    );
  }

    saveOfferToProperty(propertyId: number | undefined, data: any): Observable<any> {
        const url = `${this.urlPrefix}/property/${propertyId}`;
        return this.backend.post(url, data).pipe(
            map((response: ResponseDto) => response.response)
        );
    }

    getOffersListProperty(propertyId: any): Observable<any> {
        const url = `${this.urlPrefix}/property/${propertyId}`;
        return this.backend.get(url).pipe(
            map((response: ResponseDto) => response.response)
        );
    }

    updateOfferToProperty(propertyId: number, data: any): Observable<any> {
        const url = `${this.urlPrefix}/property/${propertyId}`;
        return this.backend.post(url, data).pipe(
            map((response: ResponseDto) => response.response)
        );
    }
}
